import { render, staticRenderFns } from "./IntegrationsVacancyImportDialog.vue?vue&type=template&id=7145f7be&scoped=true&"
import script from "./IntegrationsVacancyImportDialog.vue?vue&type=script&lang=js&"
export * from "./IntegrationsVacancyImportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7145f7be",
  null
  
)

/* custom blocks */
import block0 from "./IntegrationsVacancyImportDialog.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=en"
if (typeof block0 === 'function') block0(component)
import block1 from "./IntegrationsVacancyImportDialog.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=ru"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
